import { IMCourse } from '../types'
import { createCourse, createNodeList } from '../../nodeCreationHelpers'
import { parseUnits } from './unit'
import { PartnerKey } from '../utility'
import { createCentersNode } from './center'
import { courseOverview } from './course_overview'
import { createCourseGlossary } from './glossary'
import { createNoteNode } from './createNodeWrappers'
import { IM360Parser } from './IM360Parser'

export function parseCourse(imCourse: IMCourse) {
  const courseTitle = `IM 360 ${imCourse.title}: Powered By Kiddom`
  const gradeID = IM360Parser.getInstance(imCourse).gradeId
  const subjectID = 9994
  return createCourse(
    {
      title: courseTitle,
      gradeID,
      subjectID,
      attribution: PartnerKey,
    },
    courseChildren(imCourse),
  )
}

function courseChildren(imCourse: IMCourse) {
  return [
    ...courseNarrative(imCourse),
    ...courseOverview(imCourse),
    units(imCourse),
    ...createCourseGlossary(imCourse),
    ...centers(imCourse),
  ]
}

function courseNarrative({ narrative }: IMCourse) {
  if (!narrative) return []
  return [
    createNoteNode({
      title: 'Narrative',
      value: narrative,
      studentFacing: false,
    }),
  ]
}

function centers(imCourse: IMCourse) {
  const centers = createCentersNode(imCourse.curricula)
  if (centers) {
    return [centers]
  }
  return []
}

function units(imCourse: IMCourse) {
  return createNodeList(
    {
      title: 'Units',
    },
    parseUnits(imCourse),
  )
}
